<div class="footer-container">
    <div class="container">
        <div class="row align-items-center justify-content-between">
            <div class="col-8">
                <a href="https://www.kuparisolutions.fi/" target="_blank">
                    <img src="/assets/img/logo/kupari-vertical.svg" alt="Kupari Solutions Oy">
                </a>
            </div>

            <div class="col-auto text-xs">
                <span>&copy; Kupari Solutions Oy</span>
            </div>
        </div>
    </div>
</div>
